var render, staticRenderFns
import script from "./formatterTask.vue?vue&type=script&lang=js&"
export * from "./formatterTask.vue?vue&type=script&lang=js&"
import style0 from "./formatterTask.vue?vue&type=style&index=0&id=32ea7c4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ea7c4a",
  null
  
)

export default component.exports